window._AutofillCallbackHandler = window._AutofillCallbackHandler || (() => {});
